<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->

  <div style="height: inherit" class="manage-news">
    <div
      class="body-content-overlay"
      :class="{ show: mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = false"
    />

    <!-- <div class="header-new-action">
      </div> -->

    <!-- Email List -->
    <!-- <div class="expand-icon-news-list" v-if="newsListCollapsed">
      <feather-icon
        icon="ChevronRightIcon"
        size="26"
        class="cursor-pointer"
        @click="newsListCollapsed = false"
      />
    </div> -->
    <div
      class="email-app-list email-app-list-with-detail"
      :class="{
        'news-list-collapse': newsListCollapsed,
      }"
    >
      <!-- App Searchbar Header -->
      <div class="app-fixed-search">
        <!-- Searchbar -->
        <div class="md-12">
          <b-input-group :class="{'field-overlay': displayCalendar}">
            <b-input-group-prepend is-text class="btn-propend">
              <b-button
                variant="flat-primary"
                size="sm"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="btn-search-collapse"
                @click="filterDrawerVisible = !filterDrawerVisible"
              >
                <feather-icon
                  icon="SearchIcon"
                  :badge="totalFilterSelected"
                  :badge-classes="{
                    'badge-danger': true,
                    'badge-glow': true,
                    'badge-filter': true,
                  }"
                />
              </b-button>
              <!-- <b-badge variant="danger" class="badge-filter">1</b-badge> -->
            </b-input-group-prepend>
              <v-select
              id="searchquery-list"
              v-model="searchQuery"
              multiple
              taggable
              push-tags
              :closeOnSelect="true"
              :placeholder="$t('MANAGE_NEWS_FILTER.Search')"
              class="search-publish"
              :class="{'search-publish-draft': isDraftEventStatus}"
            >
              <span slot="no-options"></span>
            </v-select>

            <b-input-group-append>
              <b-dropdown variant="outline-primary" right class="btn-drop-search" size="sm" >
                <template #button-content>
                    <!-- :icon="currentFilterTemplate.icon" -->
                  <feather-icon
                    :icon="currentFilterType.icon"
                    class="mr-1"
                  />
                  <!-- <span class="mr-1">{{$t('TEMPLATE')[currentFilterType.i18n]}}</span> -->
                  <span class="mr-1">{{$t('TEMPLATE')[currentFilterTemplate.i18n]}}</span>
                </template>
                <!-- <b-dropdown-item>
                  <feather-icon
                    icon="CheckSquareIcon"
                    class="text-primary"
                  />
                  {{currentFilterTemplate.name}}
                </b-dropdown-item> -->
                <!-- <b-dropdown-item v-for="(item, index) in listNewsType" :key="index" @click="onSelectNewsTypeFilter(item)"> -->
                <b-dropdown-item v-for="(item, index) in listTemplate" :key="index" @click="onSelectTemplateFilter(item)">
                  <feather-icon
                    :icon="item.icon"
                    class="text-primary"
                  />
                  {{$t('TEMPLATE')[item.i18n]}}
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
            
            <!-- <b-button
              variant="flat-primary"
              size="sm"
              class="btn-delete-all-draft"
              v-b-tooltip.hover.right="'Calendário'"
              @click="openCalendar"
            >
              <feather-icon
                icon="CalendarIcon"
                size="14"
                class="cursor-pointer"
              />
            </b-button> -->

            <b-button
              v-if="isDraftEventStatus"
              variant="flat-primary"
              size="sm"
              class="btn-delete-all-draft"
              @click="onDeleteAllDraftNews"
            >
              <feather-icon
                icon="TrashIcon"
                size="14"
                class="cursor-pointer"
              />
            </b-button>
          </b-input-group>
         
        </div>
      </div>

      <!-- Filtros rápidos e chips ficam aqui; os campos ficam no drawer aberto pela lupa.
           O componente precisa ficar montado: os onFilterX e o fetchNews usam $refs.manageNewsFilter -->
      <manage-news-filter
        ref="manageNewsFilter"
        v-if="displayFilter"
        :filterData="filterData"
        :totalRows="totalRows"
        :selectedFilter="filter"
        :drawerVisible="filterDrawerVisible"
        :showInline="!displayCalendar"
        @drawer-change="filterDrawerVisible = $event"
        @onClear="onClearFilter"
        @onFilter="onFilter"
        class="filters"
      ></manage-news-filter>

      <!-- Emails List -->
      <vue-perfect-scrollbar
        v-if="!displayCalendar"
        :settings="perfectScrollbarSettings"
        class="email-user-list scroll-area"
        :suppressScrollX="true"
        @ps-y-reach-end="scrollHandleToEnd"
      >
        <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
          <ul class="email-media-list" :class="{'h-100-p': newsData.length > 0}">
            <manage-news-list-item
              ref="manageNewsListItem"
              :newsData="newsData"
              :currentEventStatusFilter="filter.event_status"
              @open-news-view="openNewsView"
              @action-edit="onEditData"
              @action-copy="onCopyData"
              @action-disable="onDisableData"
              @action-cancel="onCancelData"
              @action-errata="onCopyData"
              @action-filter-subject="onFilterSubject"
              @action-filter-user="onFilterUser"
              @action-filter-origin="onFilterOrigin"
              @action-filter-flashes="onFilterFlashes"
              @action-filter-exclusive="onFilterExclusive"
              @action-filter-important="onFilterImportant"
              @action-filter-inLive="onFilterInLive"
            ></manage-news-list-item>
          </ul>
          <div class="no-results" :class="{ show: !newsData.length }">
            <span class="not-found">
              <b-alert
                v-height-fade.appear
                variant="danger"
                :show="!newsData.length"
                class="mb-0"
              >
                <div class="alert-body">
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  {{$t('MANAGE_NEWS.NotFound')}}
                </div>
              </b-alert>
            </span>
          </div>
        </b-overlay>
      </vue-perfect-scrollbar>
    </div>

    <div
      class="manage-news-content"
      :class="{ 'full-width': newsListCollapsed, 'full-width': displayCalendar }"
    >
      <manage-action-button
        v-if="!dashboardParams || !displaySendNewsForm"
        @action-create-news="openSendNews(false)"
        @action-flashes="openSendNews(true)"
        @action-media="openModalLibrary"
        @action-import-calendar="openModalImportCalendar"
        @action-calendar="openCalendar"
      ></manage-action-button>

      <dashboard
        :class="{ show: dashboardParams }"
        v-if="dashboardParams"
        @close="closeDashBoard"
      ></dashboard>

      <calendar
        ref="calendar-page"
        :class="{ show: displayCalendar }"
        v-if="displayCalendar"
        @close="closeCalendar"
        @action-edit="onEditData"
        @action-copy="onCopyData"
        @action-schedule="onScheduleData"
        @action-publish="onPublishData"
        @action-disable="onDisableData"
        @action-cancel="onCancelData"
        @action-errata="onCopyData"
      ></calendar>

      <b-modal
        modal-class="modal-primary custom-image-library-modal"
        ref="modal-import-calendar"
        size="xl"
        ok-title="Inserir"
        ok-only
      >
        <import-calendar
          @close="closeModalImportCalendar"
        >
        </import-calendar>
      </b-modal>

      <!-- Email View/Detail -->
      <!-- :news-view-data="newsViewData" -->
      <manage-news-view
        v-if="showNewsDetails"
        :class="{ show: showNewsDetails }"
        :newsViewData="newsViewData"
        @action-edit="onEditData"
        @action-copy="onCopyData"
        @action-schedule="onScheduleData"
        @action-publish="onPublishData"
        @action-disable="onDisableData"
        @action-cancel="onCancelData"
        @action-errata="onCopyData"
        @close="closeView"
        @action-filter-subject="onFilterSubject"
        @action-filter-user="onFilterUser"
        @action-filter-origin="onFilterOrigin"
        @action-filter-flashes="onFilterFlashes"
        @action-filter-highlight="onFilterHighlight"
        @action-filter-exclusive="onFilterExclusive"
        @action-filter-important="onFilterImportant"
        @action-filter-inLive="onFilterInLive"
        @open-related-news="openRelatedNews"
        @open-news-view="openRelatedNews"
        @reindex-news="onReIndexNews"
        @refresh-news="onRefreshNews"
        @remove-elastic-from="onRemoveFromElastic"
        @restore-elastic="onRestoreToElastic"
        @vectorize-news="onVectorizeNews"
      />
      
      <send-news-tabs
        :class="{ show: displaySendNewsForm && !showNewsDetails }"
        v-if="displaySendNewsForm && !showNewsDetails"
        @updated-status-editing="changeToUpdatingFilter"
        @load-news-data="fetchNews"
        @close="onCloseSendNews"
      ></send-news-tabs>
    </div>

    <b-modal
      modal-class="modal-primary custom-image-library-modal"
      ref="modal-image-library"
      size="xl"
      ok-title="Inserir"
      ok-only
    >
      <image-library-list
        :sendNews="false"
        @close="closeModalLibrary"
      ></image-library-list>
    </b-modal>

  </div>
</template>

<script>
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import { ref, computed, watch, onUnmounted, onMounted } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import {
  BButton,
  BInputGroupPrepend,
  BOverlay,
  BModal,
  VBTooltip,
  BAlert,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { filterTags, formatDateToMonthShort } from "@core/utils/filter";
import { useRouter } from "@core/utils/utils";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";
// import ManageNewsLeftSidebar from "./ManageNewsLeftSidebar.vue";
import SendNewsTabs from "../SendNewsTabs.vue";
import ManageNewsView from "./ManageNewsView.vue";
import ManageNewsFilter from "./ManageNewsFilter.vue";
import ManageNewsListItem from "./ManageNewsListItem.vue";
import appConstants from "@/appConstants";
import newsService from "@/providers/newsService";
import axios from "axios";
import dropdownService from "@/providers/dropdownService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import newsStoreModule from "../newsStoreModule";
import store from "@/store";
import AppConstants from "@/appConstants";
import ImageLibraryList from "@/views/admin/image-library/ImageLibraryList.vue";
import imageLibStoreModule from "@/views/admin/image-library/imageLibStoreModule";
import { heightFade } from "@core/directives/animations";
import Dashboard from "@/views/pages/dashboard/Dashboard.vue";
import Calendar from "@/views/pages/calendar-events/Calendar.vue";
import ManageActionButton from "@/views/pages/news/ManageActionButton.vue";
import messageDialogHelper from '@/helpers/message-dialog-helper';
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import { EventBus } from '@/event-bus';
import ImportCalendar from "../../import-calendar/ImportCalendar.vue";

let that;

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
    "height-fade": heightFade,
  },
  components: {
    Calendar,
    ManageActionButton,
    Dashboard,
    BAlert,
    BModal,
    ImageLibraryList,
    vSelect,

    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BOverlay,
    // CustomFilter,
    // BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    // BPopover,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // App SFC
    // ManageNewsLeftSidebar,
    ManageNewsView,
    ManageNewsListItem,
    ManageNewsFilter,
    SendNewsTabs,
    ImportCalendar
  },
  computed: {
    keymap() {
      return {
        'ctrl+f1': this.hotKeyCreateNewsTab,
        'ctrl+f2': this.hotKeyCreateFlashesTab,
        'ctrl+f3': this.hotKeyCreateTvCastTab,
        'ctrl+f4': this.hotKeyCreatePodcastTab,
        'ctrl+f5': this.hotKeyCreateReportTab,
      }
    },
    draftNewsList() {
      return this.$store.state.manageNews.draft_news;
    },
    isDraftEventStatus() {
      return this.currentEventStatus.id == AppConstants.EVENT_STATUS.DRAFT;
    },
    currentUser() {
      return this.$store.state.auth.currentUser || {};
    },
    userCore() {
      return this.$store.state.auth.userCore || {};
    },
  },
  watch: {
    // currentEventStatus(value) {
    //   console.log('[watch][currentEventStatus] ', value);
    //   // this.filter.event_status = value;
    //   // this.newsViewData = {};
    //   // this.displaySendNewsForm = false;
    //   // this.currentSelectedNewsId = null;
    //   // this.updateRouteQuery();
    //   // // this.fetchNews();
    //   // if (value.id == appConstants.EVENT_STATUS.DRAFT) {
    //   //   this.fetchDraftNews();
    //   // } else {
    //   //   this.fetchNews();
    //   // }
    // },
  },
  methods: {
    openModalLibrary() {
      this.$refs["modal-image-library"].show();
    },
    openModalImportCalendar() {
      this.$refs["modal-import-calendar"].show();
    },
    closeModalLibrary() {
      this.$refs["modal-image-library"].hide();
    },
    closeModalImportCalendar() {
      this.$refs["modal-import-calendar"].hide();
    },
    fetchDraftNews() {
      // console.log('fetchDraftNews: ',this.draftNewsList);
      this.newsData = this.draftNewsList.map((item) => {
        return item;
      });
    },
  },
  created() {
    that = this;
    this.$store.dispatch("manageNews/updateDisplayFilter", true);

    EventBus.$on('current-event-status', (value) => {
      console.log('[eventbus][current-event-status]', value);
      // if (value.id == appConstants.EVENT_STATUS.DRAFT) {
      //   this.fetchDraftNews();
      // } else {
        this.fetchNews();
      // }
    })
  },
  beforeDestroy() {
    this.$store.dispatch("manageNews/updateDisplayFilter", false);
    EventBus.$off('current-event-status');
  },
  setup() {
    const { route, router } = useRouter();
    
    // const route = context.$route;
    // const router = context.$router;

    const displayCalendar = ref(false);
    const listTemplate = ref(AppConstants.LIST_TEMPLATE);
    const listNewsType = ref(AppConstants.NEWS_TYPE_LIST);
    const displayFilter = ref(false);
    const newsListCollapsed = ref(false);
    const filterDrawerVisible = ref(false);
    // Register module
    if (!store.hasModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME)) {
      store.registerModule(
        AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME,
        imageLibStoreModule
      );
    }
    if (!store.hasModule(AppConstants.NEWS_STORE_MODULE_NAME)) {
      store.registerModule(
        AppConstants.NEWS_STORE_MODULE_NAME,
        newsStoreModule
      );
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME))
        store.unregisterModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME);
    });
    onUnmounted(() => {
      if (store.hasModule(AppConstants.NEWS_STORE_MODULE_NAME))
        store.unregisterModule(AppConstants.NEWS_STORE_MODULE_NAME);
    });

    const currentSelectedNewsId = ref(null);
    const closeView = () => {
      displaySendNewsForm.value = false;
      displaySendNewsFormWithFlashes.value = false;
      newsViewData.value = {};
      that.$refs["manageNewsListItem"].currentNewsView = {};
    };

    const openSendNews = (isFlashes = false) => {
      // removeDashboardParams();
      // removeCalendarParams();
      // displaySendNewsForm.value = false;
      setTimeout(() => {
        const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));
        delete currentRouteQuery.dashboard;
        delete currentRouteQuery.calendar;
        router.replace({ query: currentRouteQuery }).catch(() => {});
        showNewsDetails.value = false;
        displaySendNewsFormWithFlashes.value = isFlashes;
        newsViewData.value = {};
        currentSelectedNewsId.value = null;
        if (that.$refs["manageNewsListItem"]) {
          that.$refs["manageNewsListItem"].currentNewsView = {};
        }
        if (store.state.report.tabs.length == 0 || displaySendNewsForm.value) {
          if (that.currentUser.profile == AppConstants.USER_PROFILE.MARKETING) {
            createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.EVENT);
          } else {
            createSendNewsTab();
          }
        } else {
          displaySendNewsForm.value = true;
        }
      }, 300);
    };
    // const EMAIL_APP_STORE_MODULE_NAME = 'app-email'

    // // Register module
    // if (!store.hasModule(EMAIL_APP_STORE_MODULE_NAME)) store.registerModule(EMAIL_APP_STORE_MODULE_NAME, emailStoreModule)

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(EMAIL_APP_STORE_MODULE_NAME)) store.unregisterModule(EMAIL_APP_STORE_MODULE_NAME)
    // })

    // const { redirectPageSendNews } = pageSendNews();
 
    // Route Params
    const stateFilter = computed(() => store.state.manageNews.filter);
    const currentEventStatus = computed(() => store.state.manageNews.currentEventStatus);

    const totalFilterSelected = ref(0);
    const updateTotalFilterSelected = () => {
      totalFilterSelected.value = 0;
      Object.keys(stateFilter.value).forEach((item) => {
        // Status "Todos" é o valor padrão (vem na URL como active=1), não conta como filtro aplicado
        if (item == "active" && Number(filter.value[item]) == AppConstants.ACTIVE.ALL) {
          return;
        }
        if (item != "event_status") {
          if (filter.value[item]) {
            totalFilterSelected.value++;
          }
        }
      });
    };



    const routeParams = computed(() => route.value.params);
    watch(routeParams, () => {
      // console.log('routeParams', routeParams.value.layout);
      // if (routeParams.value.layout == 'publisher') {
      //   console.log('publisher')
      // }
      /* eslint-disable */
      // fetchNews();
    });

    const dashboardParams = computed(() => route.value.query.dashboard);
    watch(dashboardParams, () => {
      if (dashboardParams.value) {
        showNewsDetails.value = false;
        displaySendNewsForm.value = false;
        displaySendNewsFormWithFlashes.value = false;
        isEditData.value = false;
        isCopyData.value = false;
        newsViewData.value = {};
        removeCalendarParams();
      } else {
        // showNewsDetails.value = true;
      }
    });

    const calendarParams = computed(() => route.value.query.calendar);
    watch(calendarParams, () => {
      if (calendarParams.value) {
        displayCalendar.value = true;
        showNewsDetails.value = false;
        displaySendNewsForm.value = false;
        displaySendNewsFormWithFlashes.value = false;
        isEditData.value = false;
        isCopyData.value = false;
        newsViewData.value = {};
        removeDashboardParams();
      } else {
        displayCalendar.value = false;
      }
    });

    const displayOverlay = ref(false);
    const displaySendNewsForm = ref(false);
    const displaySendNewsFormWithFlashes = ref(false);
    let newsData = ref([]);
    let totalRows = ref(0);
    let limit = ref(appConstants.PAGINATOR_DEFAULT_LIMIT);
    let currentPage = ref(1);
    let perfectScrollbarReachEnd = ref(false);
    let displaySidebarData = ref(false);
    const isEditData = ref(false);
    const isErrata = ref(false);
    const isCopyData = ref(false);

    const currentFilterTemplate = ref(AppConstants.LIST_TEMPLATE[0]);
    // const currentFilterType = ref(AppConstants.NEWS_TYPE_LIST[0]);
    const filter = ref({});
    const filterData = ref({});

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };
    const currentFilterType = computed(() => stateFilter.value.type);

    // Search Query
    const routeQuery = computed(() => route.value.query.q);
    const searchQuery = ref(routeQuery.value);
    watch(routeQuery, (val) => {
      searchQuery.value = val;
    });
    /* eslint-disable */
    watch(searchQuery, () => {
      store.dispatch("manageNews/updateFilter", { field: 'searchQuery', value: searchQuery.value })
      console.log("watch searchQuery: ", searchQuery.value);
      // console.log(this.refs['calendar-page'].refetchEvents());
      updateRouteQuery();
      if (displayCalendar.value) {
        that.$refs['calendar-page'].refetchEvents();
      } else {
        fetchNews();
      }
    });

    // const inputSearchQuery = () => {
    //   updateRouteQuery();
    //   fetchNews();
    // };

    const openCalendar = () => {
      displayCalendar.value = !displayCalendar.value;

      if (displayCalendar.value) {
        const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));
        currentRouteQuery.calendar = true;
        delete currentRouteQuery.dashboard;
        router.replace({ query: currentRouteQuery }).catch(() => {});
  
        showNewsDetails.value = false;
        displaySendNewsForm.value = false;
        displaySendNewsFormWithFlashes.value = false;
        isEditData.value = false;
        isCopyData.value = false;
        newsViewData.value = {};
        // removeDashboardParams();
      } else {
        closeCalendar();
      }
    };

    const getRouteQueryValue = () => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));
      if (currentRouteQuery.newsId) {
        filter.value.newsId = currentRouteQuery.newsId;
      }
      if (currentRouteQuery.origin) {
        filter.value.origin = { id: currentRouteQuery.origin };
      }
      if (currentRouteQuery.event_status) {
        filter.value.event_status = { id: currentRouteQuery.event_status };
        // that.$store.dispatch('manageNews/updateCurrentEventStatus', filter.value.event_status);
      }
      if (currentRouteQuery.subject) {
        filter.value.subject = { id: currentRouteQuery.subject };
      }
      if (currentRouteQuery.user) {
        filter.value.user = { id: currentRouteQuery.user };
      }
      if (currentRouteQuery.dt_range) {
        filter.value.dt_range = currentRouteQuery.dt_range;
      }
      if (currentRouteQuery.dt_end) {
        filter.value.dt_end = currentRouteQuery.dt_end;
      }
      if (currentRouteQuery.important) {
        filter.value.important = currentRouteQuery.important;
      }
      if (currentRouteQuery.inLive) {
        filter.value.inLive = currentRouteQuery.inLive;
      }
      if (currentRouteQuery.flashes) {
        filter.value.flashes = currentRouteQuery.flashes;
      }
      if (currentRouteQuery.highlight) {
        filter.value.highlight = currentRouteQuery.highlight;
      }
      if (currentRouteQuery.exclusive) {
        filter.value.exclusive = currentRouteQuery.exclusive;
      }
      if (currentRouteQuery.mostReadDay) {
        filter.value.mostReadDay = currentRouteQuery.mostReadDay;
      }
      if (currentRouteQuery.mostReadWeek) {
        filter.value.mostReadWeek = currentRouteQuery.mostReadWeek;
      }
      if (currentRouteQuery.mostReadMonth) {
        filter.value.mostReadMonth = currentRouteQuery.mostReadMonth;
      }
      if (currentRouteQuery.active) {
        filter.value.active = currentRouteQuery.active;
      }
      if (currentRouteQuery.layout) {
        filter.value.layout = currentRouteQuery.layout;
      }
      if (currentRouteQuery.type) {
        filter.value.type = currentRouteQuery.type;
      }
      if (currentRouteQuery.calendar) {
        openCalendar();
      }

      fetchDropdown();
    };

    const updateRouteQuery = () => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

      if (stateFilter.value.newsId) {
        currentRouteQuery.newsId = stateFilter.value.newsId;
      } else delete currentRouteQuery.newsId;

      if (stateFilter.value.origin) {
        currentRouteQuery.origin = stateFilter.value.origin.id;
      } else delete currentRouteQuery.origin;

      if (currentEventStatus.value && currentEventStatus.value.id) {
        currentRouteQuery.event_status = currentEventStatus.value.id;
      } else delete currentRouteQuery.event_status;

      if (stateFilter.value.subject) {
        currentRouteQuery.subject = stateFilter.value.subject.id;
      } else delete currentRouteQuery.subject;

      if (stateFilter.value.user) {
        currentRouteQuery.user = stateFilter.value.user.id;
      } else delete currentRouteQuery.user;

      if (stateFilter.value.dt_range) {
        currentRouteQuery.dt_range = stateFilter.value.dt_range;
      } else delete currentRouteQuery.dt_range;
      if (stateFilter.value.dt_create) {
        currentRouteQuery.dt_create = stateFilter.value.dt_create;
      } else delete currentRouteQuery.dt_create;
      if (stateFilter.value.dt_report) {
        currentRouteQuery.dt_report = stateFilter.value.dt_report;
      } else delete currentRouteQuery.dt_report;

      if (stateFilter.value.dt_end) {
        currentRouteQuery.dt_end = stateFilter.value.dt_end;
      } else delete currentRouteQuery.dt_end;

      if (stateFilter.value.important) {
        currentRouteQuery.important = stateFilter.value.important;
      } else delete currentRouteQuery.important;

      if (stateFilter.value.inLive) {
        currentRouteQuery.inLive = stateFilter.value.inLive;
      } else delete currentRouteQuery.inLive;

      if (stateFilter.value.flashes) {
        currentRouteQuery.flashes = stateFilter.value.flashes;
      } else delete currentRouteQuery.flashes;

      if (stateFilter.value.highlight) {
        currentRouteQuery.highlight = stateFilter.value.highlight;
      } else delete currentRouteQuery.highlight;

      if (stateFilter.value.exclusive) {
        currentRouteQuery.exclusive = stateFilter.value.exclusive;
      } else delete currentRouteQuery.exclusive;

      if (stateFilter.value.mostReadDay) {
        currentRouteQuery.mostReadDay = stateFilter.value.mostReadDay;
      } else delete currentRouteQuery.mostReadDay;

      if (stateFilter.value.mostReadWeek) {
        currentRouteQuery.mostReadWeek = stateFilter.value.mostReadWeek;
      } else delete currentRouteQuery.mostReadWeek;

      if (stateFilter.value.mostReadMonth) {
        currentRouteQuery.mostReadMonth = stateFilter.value.mostReadMonth;
      } else delete currentRouteQuery.mostReadMonth;

      if (stateFilter.value.active) {
        currentRouteQuery.active = stateFilter.value.active;
      } else delete currentRouteQuery.active;

      if (stateFilter.value.searchQuery) {
        currentRouteQuery.q = stateFilter.value.searchQuery;
      } else delete currentRouteQuery.q;

      if (currentFilterTemplate.value && currentFilterTemplate.value.id) {
        currentRouteQuery.layout = currentFilterTemplate.value.id;
      } else delete currentRouteQuery.layout;

      if (stateFilter.value.type && stateFilter.value.type.id) {
        currentRouteQuery.type = stateFilter.value.type.id;
      } else delete currentRouteQuery.type;

      router.replace({ query: currentRouteQuery }).catch(() => {});
    };

    // O status muda por vários caminhos (menu lateral via EventBus, salvar/editar notícia, padrão da 1ª carga)
    // e nenhum atualiza a URL; sem isso o F5 voltaria para o status antigo
    watch(currentEventStatus, (val, oldVal) => {
      if (val && val.id && (!oldVal || val.id != oldVal.id)) {
        updateRouteQuery();
      }
    });

    // const updateRouteQuery = () => {
    //   const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

    //   if (filter.value.newsId) {
    //     currentRouteQuery.newsId = filter.value.newsId;
    //   } else delete currentRouteQuery.newsId;

    //   if (filter.value.origin) {
    //     currentRouteQuery.origin = filter.value.origin.id;
    //   } else delete currentRouteQuery.origin;

    //   if (filter.value.event_status) {
    //     currentRouteQuery.event_status = filter.value.event_status.id;
    //   } else delete currentRouteQuery.event_status;

    //   if (filter.value.subject) {
    //     currentRouteQuery.subject = filter.value.subject.id;
    //   } else delete currentRouteQuery.subject;

    //   if (filter.value.user) {
    //     currentRouteQuery.user = filter.value.user.name;
    //   } else delete currentRouteQuery.user;

    //   if (filter.value.dt_range) {
    //     currentRouteQuery.dt_range = filter.value.dt_range;
    //   } else delete currentRouteQuery.dt_range;
    //   if (filter.value.dt_create) {
    //     currentRouteQuery.dt_create = filter.value.dt_create;
    //   } else delete currentRouteQuery.dt_create;
    //   if (filter.value.dt_report) {
    //     currentRouteQuery.dt_report = filter.value.dt_report;
    //   } else delete currentRouteQuery.dt_report;

    //   if (filter.value.dt_end) {
    //     currentRouteQuery.dt_end = filter.value.dt_end;
    //   } else delete currentRouteQuery.dt_end;

    //   if (filter.value.important) {
    //     currentRouteQuery.important = filter.value.important;
    //   } else delete currentRouteQuery.important;

    //   if (filter.value.inLive) {
    //     currentRouteQuery.inLive = filter.value.inLive;
    //   } else delete currentRouteQuery.inLive;

    //   if (filter.value.flashes) {
    //     currentRouteQuery.flashes = filter.value.flashes;
    //   } else delete currentRouteQuery.flashes;

    //   if (filter.value.highlight) {
    //     currentRouteQuery.highlight = filter.value.highlight;
    //   } else delete currentRouteQuery.highlight;

    //   if (filter.value.exclusive) {
    //     currentRouteQuery.exclusive = filter.value.exclusive;
    //   } else delete currentRouteQuery.exclusive;

    //   if (filter.value.mostReadDay) {
    //     currentRouteQuery.mostReadDay = filter.value.mostReadDay;
    //   } else delete currentRouteQuery.mostReadDay;

    //   if (filter.value.mostReadWeek) {
    //     currentRouteQuery.mostReadWeek = filter.value.mostReadWeek;
    //   } else delete currentRouteQuery.mostReadWeek;

    //   if (filter.value.mostReadMonth) {
    //     currentRouteQuery.mostReadMonth = filter.value.mostReadMonth;
    //   } else delete currentRouteQuery.mostReadMonth;

    //   if (filter.value.active) {
    //     currentRouteQuery.active = filter.value.active;
    //   } else delete currentRouteQuery.active;

    //   if (searchQuery.value) {
    //     currentRouteQuery.q = searchQuery.value;
    //   } else delete currentRouteQuery.q;

    //   if (filter.value.layout) {
    //     currentRouteQuery.layout = filter.value.layout;
    //   } else delete currentRouteQuery.layout;

    //   if (filter.value.type) {
    //     currentRouteQuery.type = filter.value.type;
    //   } else delete currentRouteQuery.type;

    //   router.replace({ query: currentRouteQuery }).catch(() => {});
    // };

    const removeDashboardParams = () => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));
      delete currentRouteQuery.dashboard;
      router.replace({ query: currentRouteQuery }).catch(() => {});
    };

    const removeCalendarParams = () => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));
      delete currentRouteQuery.calendar;
      router.replace({ query: currentRouteQuery }).catch(() => {});
    };

    const redirectPageSendNews = () => {
      router.push(appConstants.NAVIGATION_PAGE_SEND_NEWS);
    };
    
    // const openCalendarPage = () => {
    //   displayCalendarPage.value = true;
    //   // router.push(appConstants.NAVIGATION_PAGE_CALENDAR);
    // };

    const searchParams = (status = false) => {
      console.log('[searchParams][state]', stateFilter.value);
      const params = new URLSearchParams();
      params.append("page", currentPage.value);
      params.append("limit", limit.value);

      if (stateFilter.value.newsId) {
        params.append("id", stateFilter.value.newsId);
      }
      if (stateFilter.value.origin) {
        params.append("source", stateFilter.value.origin.id);
      }
      if (currentEventStatus.value && currentEventStatus.value.id) {
        params.append("event_status", currentEventStatus.value.id);
      } else {
        params.append("event_status", AppConstants.EVENT_STATUS.PUBLISHED);
      }
      if (stateFilter.value.subject) {
        params.append("subject", stateFilter.value.subject.id);
      }
      if (stateFilter.value.user) {
        params.append("user", stateFilter.value.user.id);
      }
      if (stateFilter.value.dt_range) {
        params.append("dt_range", stateFilter.value.dt_range);
      }
      if (stateFilter.value.dt_report) {
        params.append("dt_report", stateFilter.value.dt_report);
      }
      if (stateFilter.value.dt_create) {
        params.append("dt_create", stateFilter.value.dt_create);
      }
      if (stateFilter.value.dt_end) {
        params.append("dt_end", stateFilter.value.dt_end);
      }
      if (stateFilter.value.important) {
        params.append("importance", stateFilter.value.important);
      }
      if (stateFilter.value.inLive) {
        params.append("inLive", stateFilter.value.inLive);
      }
      if (stateFilter.value.flashes) {
        params.append("flashes", stateFilter.value.flashes);
      }
      if (stateFilter.value.highlight) {
        params.append("highlight", stateFilter.value.highlight);
      }
      if (stateFilter.value.exclusive) {
        params.append("exclusive", stateFilter.value.exclusive);
      }
      if (stateFilter.value.mostReadDay) {
        params.append("mostReadDay", stateFilter.value.mostReadDay);
      }
      if (stateFilter.value.mostReadWeek) {
        params.append("mostReadWeek", stateFilter.value.mostReadWeek);
      }
      if (stateFilter.value.mostReadMonth) {
        params.append("mostReadMonth", stateFilter.value.mostReadMonth);
      }
      if (stateFilter.value.active) {
        if (stateFilter.value.active == AppConstants.ACTIVE.TRUE) {
          params.append("active", true);
        }else if (stateFilter.value.active == AppConstants.ACTIVE.FALSE) {
          params.append("active", false);
        }
      }
      if (stateFilter.value.layout && stateFilter.value.layout !== undefined) {
        params.append("layout", stateFilter.value.layout);
      }

      if (currentFilterTemplate.value && currentFilterTemplate.value.id) {
        params.append("layout", currentFilterTemplate.value.id);
      }

      if (stateFilter.value.type && stateFilter.value.type.id) {
        params.append("type", stateFilter.value.type.id);
      }

      if (stateFilter.value.searchQuery) {
        params.append("searchQuery", stateFilter.value.searchQuery);
      }

      if (status) {
        params.append("status", true);
      }

      params.append(AppConstants.PARAMS_USER_FILTER, true);

      return params;
    };
    
    // Só a busca mais recente pode atualizar a tela: ao trocar de status/filtro com uma busca lenta em andamento
    // (ex.: "Publicado"), a resposta antiga chegava depois e sobrescrevia a lista do status selecionado
    let fetchNewsRequestId = 0;
    let fetchNewsCancelSource = null;

    const fetchNews = (isPaginate = false) => {
      if (!isPaginate) {
        currentPage.value = 1;
        perfectScrollbarReachEnd.value = false;
        newsData.value = [];
      }
      if (fetchNewsCancelSource) {
        fetchNewsCancelSource.cancel('fetchNews: substituída por uma busca mais recente');
      }
      const cancelSource = axios.CancelToken.source();
      const requestId = ++fetchNewsRequestId;
      fetchNewsCancelSource = cancelSource;
      const isCurrentRequest = () => requestId === fetchNewsRequestId;

      displayOverlay.value = true;
      newsService
        .manageNews(searchParams(), { cancelToken: cancelSource.token })
        .then((res) => {
          if (!isCurrentRequest()) return;
          fetchNewsCancelSource = null;
          totalRows.value = res.totalRows;
          if (isPaginate) {
            if (res.data.length > 0) {
              perfectScrollbarReachEnd.value = false;
            }
            newsData.value = newsData.value.concat(res.data);
          } else {
            newsData.value = res.data;
          }
          displayOverlay.value = false;
          that.$refs["manageNewsFilter"].resetClearStatus();
          updateEventStatus();
          setTimeout(() => {
            updateTotalFilterSelected();
          },1000);
          that.$forceUpdate();
        })
        .catch((err) => {
          // busca cancelada/antiga: o overlay pertence à busca atual, que ainda está em andamento
          if (axios.isCancel(err) || !isCurrentRequest()) return;
          fetchNewsCancelSource = null;
          console.log(err);
          displayOverlay.value = false;
        });
    };

    onUnmounted(() => {
      if (fetchNewsCancelSource) {
        fetchNewsCancelSource.cancel('fetchNews: tela de publicações fechada');
      }
    });

    const fetchNewsDetail = (newsId) => {
      newsViewData.value = {};
      currentSelectedNewsId.value = null;
      newsService
        .getNewsDetail(newsId, new URLSearchParams())
        .then((res) => {
          newsViewData.value = res;
          currentSelectedNewsId.value = res._id;
          updateCurrentNewsViewOnList();
          that.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const updateCurrentNewsViewOnList = () => {
      if (currentSelectedNewsId.value) {
        const data = newsData.value.find(
          (item) => item._id == currentSelectedNewsId.value
        );
        if (data) {
          newsViewData.value = data;
          that.$refs["manageNewsListItem"].currentNewsView = newsViewData.value;
          showNewsDetails.value = true;
        } else {
          that.$refs["manageNewsListItem"].currentNewsView = {};
        }
        // currentSelectedNewsId.value = null;
      }
    };

    const updateEventStatus = () => {
      newsService
        .getEventStatusWithStatistic(searchParams(true))
        .then((res) => {
          filterData.value.event_status = res;
          if (!filter.value.event_status) {
            filter.value.event_status = res[0];
          }
          store.dispatch("manageNews/updateEventStatus", res);
          if (!currentEventStatus.value.id) {
            updateCurrenEventStatus(res[0] ? res[0].id : AppConstants.EVENT_STATUS.PUBLISHED);
          }

          that.$forceUpdate();
          updateCurrentNewsViewOnList();
          // displayFilter.value = true;
        })
        .catch();
    };

    // Filtros lidos da URL em getRouteQueryValue que o searchParams envia a partir do store
    const ROUTE_FILTER_FIELDS = [
      'newsId', 'origin', 'subject', 'dt_range', 'dt_end', 'important', 'inLive', 'flashes',
      'highlight', 'exclusive', 'mostReadDay', 'mostReadWeek', 'mostReadMonth', 'active',
    ];
    const syncRouteFilterToStore = () => {
      ROUTE_FILTER_FIELDS.forEach((field) => {
        if (filter.value[field]) {
          store.dispatch("manageNews/updateFilter", { field, value: filter.value[field] });
        }
      });
      if (searchQuery.value) {
        store.dispatch("manageNews/updateFilter", { field: 'searchQuery', value: searchQuery.value });
      }

      // Usuário: só aceita id da lista (URLs antigas guardavam o e-mail e o backend espera ObjectId)
      if (filter.value.user) {
        const user = (filterData.value.users || []).find((item) => item.id == filter.value.user.id);
        if (user) {
          filter.value.user = user;
          store.dispatch("manageNews/updateFilter", { field: 'user', value: user });
        } else {
          delete filter.value.user;
        }
      }

      // Status da URL (ex.: F5 em "Editando"); sem ele o updateEventStatus assume o primeiro da lista
      if (filter.value.event_status && filter.value.event_status.id) {
        const eventStatus = AppConstants.EVENT_STATUS_MENU.find((item) => item.id == filter.value.event_status.id);
        if (eventStatus) {
          updateCurrenEventStatus(eventStatus.id);
        }
      }

      // Template (Todos, Notícia, Pisca...) selecionado no dropdown ao lado da busca
      if (filter.value.layout) {
        const template = AppConstants.LIST_TEMPLATE.find((item) => item.id == filter.value.layout);
        if (template) {
          currentFilterTemplate.value = template;
        }
      }
    };

    const fetchDropdown = () => {
      const userParams = new URLSearchParams();
      userParams.append(appConstants.PARAMS_USER_FILTER, true);
      const eventStatusParams = new URLSearchParams();
      eventStatusParams.append("status", true);
      Promise.all([
        // dropdownService.getAllOrigin(userParams),
        // dropdownService.getAllSubjects(userParams),
        dropdownService.getUsers(new URLSearchParams()),
        newsService.getDetailUserCore(new URLSearchParams()),
      ])
        .then((res) => {
          // filterData.value.origins = res[0];
          // filterData.value.subjects = res[1];
          filterData.value.users = res[0];

          store.dispatch("auth/setUserCore", res[1]);
          filterData.value.origins = that.userCore.origins.map(item => {
            item.id = item['_id'];
            return item;
          });
          filterData.value.subjects = that.userCore.subjects.map(item => {
            item.id = item['_id'];
            return item;
          });
     
          const currentRouteQuery = JSON.parse(
            JSON.stringify(route.value.query)
          );
     
          // Current date
          if (!currentRouteQuery.dt_range) {
            filter.value.dt_range = convertDatetimeHelper.convertDateParams(new Date());
            // store.dispatch("manageNews/updateFilter", { field: 'dt_range', value: convertDatetimeHelper.convertDateParams(new Date()) });
            // // filter.value.dt_range = `${dt.getFullYear()}-${dt.getMonth() +
            // //   1}-${dt.getDate()}`;
            // updateRouteQuery();
            // updateTotalFilterSelected();
            // that.$forceUpdate();
          }
          // Primeira busca única já com os filtros da URL; o ManageNewsFilter só restaura a tela
          // (antes cada filtro restaurado disparava um fetchNews + estatística)
          syncRouteFilterToStore();
          updateRouteQuery();
          fetchNews();
          displayFilter.value = true;
          // displaySidebarData.value = true;
          
        })
        .catch((err) => console.log(err));
    };

    const fetchDropdownByOrigin = (origin) => {
      const params = new URLSearchParams();
      params.append("origins", [origin]);
      params.append(appConstants.PARAMS_USER_FILTER, true);
      Promise.all([
        dropdownService.getAllSubjects(params),
        dropdownService.getUsers(params),
      ])
        .then((res) => {
          // filterData.value.subjects = res[0];
          filterData.value.users = res[1];
        })
        .catch((err) => console.log(err));
    };

    const onFilter = (data) => {
      data.event_status = filter.value.event_status;
      filter.value = data;
      updateRouteQuery();
      // console.log('OnFilter: ', filter.value);
      // if (filter.value.origin) {
      //   fetchDropdownByOrigin(filter.value.origin.id);
      // }
      fetchNews();
    };

    const onClearFilter = (val) => {
      store.dispatch("manageNews/clearFilter");
      const currentEvent = filter.value.event_status;
      filter.value = val;
      filter.value.event_status = currentEvent;
      currentFilterTemplate.value = AppConstants.LIST_TEMPLATE[0];
      // currentFilterType.value = AppConstants.NEWS_TYPE_LIST[0];
      updateRouteQuery();
      // console.log('OnFilter: ', this.filter);
      fetchNews();
    };

    const changeToUpdatingFilter = (newsId) => {
      filter.value.event_status = { id: AppConstants.EVENT_STATUS.EDITING };
      changeStatusFilter(newsId, AppConstants.EVENT_STATUS.EDITING);
    };
    const changeToScheduleFilter = (newsId) => {
      filter.value.event_status = { id: AppConstants.EVENT_STATUS.SCHEDULED };
      changeStatusFilter(newsId, AppConstants.EVENT_STATUS.SCHEDULED);
    };
    const changeToPublishedFilter = (newsId) => {
      filter.value.event_status = { id: AppConstants.EVENT_STATUS.PUBLISHED };
      changeStatusFilter(newsId, AppConstants.EVENT_STATUS.PUBLISHED);
    };
    const changeToStoreFilter = (newsId) => {
      filter.value.event_status = { id: AppConstants.EVENT_STATUS.SAVED };
      changeStatusFilter(newsId, AppConstants.EVENT_STATUS.SAVED);
    };

    const changeStatusFilter = (newsId, eventStatusCode) => {
      if (newsId) {
        currentSelectedNewsId.value = newsId;
      }
      updateCurrenEventStatus(eventStatusCode);
    }

    const hotKeyCreateNewsTab = () => {
      createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.NEWS);
    };
    const hotKeyCreateFlashesTab = () => {
      createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.FLASHES);
    };
    const hotKeyCreateTvCastTab = () => {
      createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.TVCAST);
    };
    const hotKeyCreatePodcastTab = () => {
      createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.PODCAST);
    };
    const hotKeyCreateReportTab = () => {
      createSendNewsTab(false, false, false, {}, {}, AppConstants.NEWS_LAYOUT.REPORT);
    };

    const createSendNewsTab = (isEdit = false, isCopy = false, isErrata = false, editData = {}, draftData = {}, template = AppConstants.NEWS_LAYOUT.NEWS) => {
      // displaySendNewsForm.value = false;
      setTimeout(() => {
        displaySendNewsForm.value = true;
        store.dispatch("report/newTab", {
          isEdit: isEdit, 
          isCopy: isCopy, 
          isErrata: isErrata, 
          editData: editData, 
          draftData: draftData,
          startTemplate: template
        });
      }, 300);
      // store.dispatch("report/updateTabIndex");
    };

    const onEditData = (data) => {
      // console.log("onEditData");
      closeCalendar();
      showNewsDetails.value = false;
      isEditData.value = true;
      isCopyData.value = false;
      isErrata.value = false;

      createSendNewsTab(true, false, false, data);
      
      // if (displaySendNewsForm.value) {
      //   displaySendNewsForm.value = false;
      //   newsViewData.value = {};
      // }
      // setTimeout(() => {
      //   newsViewData.value = data;
      //   displaySendNewsForm.value = true;
      // }, 500);
      // router.push(`${appConstants.NAVIGATION_PAGE_SEND_NEWS}/${data._id}`);
    };
    const onCopyData = (data, errata = false) => {
      // console.log("onCopyData");
      closeCalendar();
      showNewsDetails.value = false;
      isEditData.value = false;
      isErrata.value = errata;
      isCopyData.value = true;

      createSendNewsTab(false, true, errata, data);

      // if (displaySendNewsForm.value) {
      //   displaySendNewsForm.value = false;
      //   newsViewData.value = {};
      //   setTimeout(() => {
      //     newsViewData.value = data;
      //     displaySendNewsForm.value = true;
      //   }, 500);
      // } else {
      //   newsViewData.value = data;
      //   displaySendNewsForm.value = true;
      // }
      // router.push({
      //   path: `${appConstants.NAVIGATION_PAGE_SEND_NEWS}/${data._id}`,
      //   query: { copy: true },
      // });
    };
    const onScheduleData = (data) => {
      // console.log("onCopyData");
      // showNewsDetails.value = false;
      const form = {
        _id: data._id,
        dt_scheduled: data.dt_scheduled,
      };
      newsService
        .scheduleNews(form, new URLSearchParams())
        .then(() => {
          changeToScheduleFilter(data._id);
          messagesNotifyHelper.successNotify(
            "Agendamento",
            "Notícia agendada com sucesso!"
          );
          fetchNews();
        })
        .catch((err) => console.log(err));
    };
    const onPublishData = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja publicar a noticia?', () => {
        // console.log("onCopyData");
        showNewsDetails.value = false;
        newsService
          .publishNews(data._id, new URLSearchParams())
          .then(() => {
            changeToPublishedFilter(data._id);
            messagesNotifyHelper.successNotify(
              "Publicação",
              "Notícia publicada com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };
    const onStoreData = (data) => {
      // console.log("onCopyData");
      showNewsDetails.value = false;
      const form = {
        _id: data._id,
      };
      newsService
        .publishNews(form, new URLSearchParams())
        .then(() => {
          changeToStoreFilter(data._id);
          messagesNotifyHelper.successNotify(
            "Publicação",
            "Notícia salva com sucesso!"
          );
          fetchNews();
        })
        .catch((err) => console.log(err));
    };
    const onDisableData = (data) => {
      messageDialogHelper.displayConfirmMessage('Desabilitar notícia', 'Deseja desabilitar a noticia?', () => {
        newsService
          .disableNews(data._id, new URLSearchParams())
          .then(() => {
            messagesNotifyHelper.successNotify(
                "Desabilitar",
                "Notícia desabilitado com sucesso!"
              );
            newsViewData.value = {};
            displaySendNewsForm.value = false;
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };
    const onCancelData = (data) => {
      messageDialogHelper.displayConfirmMessage('Cancelar notícia', 'Deseja cancelar a noticia?', () => {
        newsService
          .cancelNews(data._id, new URLSearchParams())
          .then(() => {
            if (data.event_status == AppConstants.EVENT_STATUS.DRAFT) {
              messagesNotifyHelper.successNotify(
                "Deleção",
                "Rascunho deletado com sucesso!"
              );
            } else {
              messagesNotifyHelper.successNotify(
                "Cancelamento",
                "Notícia cancelada com sucesso!"
              );
            }
            newsViewData.value = {};
            displaySendNewsForm.value = false;
            // this.currentSelectedNewsId = data._id;
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };
    const scrollHandleToEnd = () => {
      // console.log(evt);
      if (!newsData.value.length) {
        return;
      }
      if (perfectScrollbarReachEnd.value) {
        return;
      }
      if (newsData.value.length < 10)  {
        return;
      }
      if (!perfectScrollbarReachEnd.value) {
        perfectScrollbarReachEnd.value = true;
        // console.log(evt);
        loadMorePage();
      }
    };

    const loadMorePage = () => {
      currentPage.value++;
      // console.log(currentPage.value);
      fetchNews(true);
    };

    const onCloseSendNews = (newData) => {
      newsViewData.value = {};
      // showNewsDetails.value = true;
      displaySendNewsForm.value = false;
      displaySendNewsFormWithFlashes.value = false;
      if (newData) {
        currentSelectedNewsId.value = newData._id;
        if (currentEventStatus.value.id != newData.event_status) {
          updateCurrenEventStatus(newData.event_status);
        }
      }

      // if (filter.value.event_status.id == appConstants.EVENT_STATUS.DRAFT) {
      //   that.fetchDraftNews();
      // } else {}
      fetchNews();
    };
    
    const updateCurrenEventStatus = (eventStatusCode) => {
      console.log('[updateCurrenEventStatus]', eventStatusCode);
      store.dispatch("manageNews/updateCurrentEventStatus", { id: eventStatusCode});
    }

    const closeDashBoard = () => {
      showNewsDetails.value = true;
      newsViewData.value = {};
      removeDashboardParams();
    };

    const closeCalendar = () => {
      showNewsDetails.value = true;
      newsViewData.value = {};
      removeCalendarParams();
      displayCalendar.value = false;
    };

    // ------------------------------------------------
    // Email Details
    // ------------------------------------------------
    let showNewsDetails = ref(true);
    let newsViewData = ref({});
    const openNewsView = (news) => {
      removeDashboardParams();
      removeCalendarParams();
      showNewsDetails.value = true;
      displaySendNewsForm.value = false;
      displaySendNewsFormWithFlashes.value = false;
      isEditData.value = false;
      isCopyData.value = false;
      isErrata.value = false;

      newsViewData.value = news;
      currentSelectedNewsId.value = null;
      // if (news.isDraft) {
      //   displaySendNewsForm.value = true;
      // }
    };

    // * If someone clicks on filter while viewing detail => Close the email detail view
    watch(routeParams, () => {
      // showNewsDetails.value = false;
    });

    // * Watcher to reset selectedEmails
    // ? You can also use showNewsDetails (instead of `newsViewData`) but it will trigger execution twice in this case
    /* eslint-disable */
    watch([newsViewData, routeParams], () => {
      // selectedEmails.value = [];
    });

    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility();

    mqShallShowLeftSidebar.value = false;


    if (dashboardParams.value || calendarParams.value) {
      showNewsDetails.value = false;
    }

    const onFilterSubject = (item) => {
      item.id = item._id;
      that.$refs["manageNewsFilter"].subjectModel = item;
      that.$refs["manageNewsFilter"].currentFilter.subject = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterOrigin = (item) => {
      item.id = item._id;
      that.$refs["manageNewsFilter"].originModel = item;
      that.$refs["manageNewsFilter"].currentFilter.origin = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterFlashes = (item) => {
      that.$refs["manageNewsFilter"].flashes = item;
      that.$refs["manageNewsFilter"].currentFilter.flashes = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };
    const onFilterHighlight = (item) => {
      that.$refs["manageNewsFilter"].highlight = item;
      that.$refs["manageNewsFilter"].currentFilter.highlight = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterExclusive = (item) => {
      that.$refs["manageNewsFilter"].exclusive = item;
      that.$refs["manageNewsFilter"].currentFilter.exclusive = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterUser = (item) => {
      item.id = item._id;
      that.$refs["manageNewsFilter"].userModel = item;
      that.$refs["manageNewsFilter"].currentFilter.user = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterImportant = (item) => {
      that.$refs["manageNewsFilter"].important = item;
      that.$refs["manageNewsFilter"].currentFilter.important = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onFilterInLive = (item) => {
      that.$refs["manageNewsFilter"].inLive = item;
      that.$refs["manageNewsFilter"].currentFilter.inLive = item;
      onFilter(that.$refs["manageNewsFilter"].currentFilter);
    };

    const onSelectTemplateFilter = (item) => {
      filter.value.layout = item.id;
      console.log(item)
      currentFilterTemplate.value = item;
      updateRouteQuery();
      fetchNews();
    }

    const onSelectNewsTypeFilter = (item) => {
      store.dispatch("manageNews/updateFilter", { field: 'type', value: item })
      filter.value.type = item.id;
      console.log(item)
      // currentFilterType.value = item;
      fetchNews();
    }

    const openRelatedNews = (item) => {
      fetchNewsDetail(item._id);
    }

    const onDeleteAllDraftNews = () => {
      messageDialogHelper.displayConfirmMessage('Deletar','Deseja apagar TODOS os rascunhos?', ()=> {
        newsService.deleteAllDraftNews(new URLSearchParams())
        .then((res) => {
          messageDialogHelper.displaySuccessMess(`Deletado ${res} rascunhos`);
          fetchNews();
        });
      });
    }

    const onReIndexNews = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja reindexar a noticia no elasticsearch?', () => {
        const params = new URLSearchParams();
        params.append('id', data._id);
        newsService.reIndexNews(params).then(() => {
          messagesNotifyHelper.successNotify(
              "Publicação",
              "Notícia indexado com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };
    const onRefreshNews = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja dar refresh das noticias no elasticsearch?', () => {
        const params = new URLSearchParams();
        params.append('id', data._id);
        newsService.refreshNewsElastic(params).then(() => {
          messagesNotifyHelper.successNotify(
              "Publicação",
              "Refresh das noticias no elasticsearch realizado com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };
    const onRemoveFromElastic = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja remover o conteudo do elasticsearch? Ele não volta para a busca nas sincronizações; só ao restaurar ou publicar a notícia novamente.', () => {
        const params = new URLSearchParams();
        params.append('id', data._id);
        newsService.removeFromElasticsearch(params).then(() => {
          messagesNotifyHelper.successNotify(
              "Publicação",
              "Notícia removido do elasticsearch com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };

    const onRestoreToElastic = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja restaurar a notícia no elasticsearch?', () => {
        const params = new URLSearchParams();
        params.append('id', data._id);
        newsService.restoreToElasticsearch(params).then(() => {
          messagesNotifyHelper.successNotify(
              "Publicação",
              "Notícia restaurada no elasticsearch com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };

    const onVectorizeNews = (data) => {
      messageDialogHelper.displayConfirmMessage('Publicação', 'Deseja vetorizar a noticia?', () => {
        const params = new URLSearchParams();
        params.append('id', data._id);
        newsService.vectorizeNews(params).then(() => {
          messagesNotifyHelper.successNotify(
              "Publicação",
              "Notícia vetorizada com sucesso!"
            );
            fetchNews();
          })
          .catch((err) => console.log(err));
      })
    };

    onMounted(()=>{
      getRouteQueryValue();
    })

    return {
      currentFilterTemplate,
      currentFilterType,
      totalFilterSelected,
      updateTotalFilterSelected,
      filterDrawerVisible,
      newsListCollapsed,

      // UI
      perfectScrollbarSettings,
      dashboardParams,
      calendarParams,

      // Email Details
      showNewsDetails,
      newsViewData,
      openNewsView,

      // Search Query
      searchQuery,
      updateRouteQuery,
      getRouteQueryValue,

      // UI Filters
      filterTags,
      formatDateToMonthShort,

      // Left Sidebar Responsiveness
      mqShallShowLeftSidebar,

      redirectPageSendNews,

      isEditData,
      isCopyData,
      isErrata,
      displayOverlay,
      displaySendNewsForm,
      displaySendNewsFormWithFlashes,
      newsData,
      totalRows,
      limit,
      currentPage,
      filter,
      filterData,
      perfectScrollbarReachEnd,
      displaySidebarData,
      listTemplate,
      listNewsType,
      displayFilter,
      displayCalendar,

      // Methods
      fetchNewsDetail,
      onStoreData,
      onClearFilter,
      onFilter,
      onEditData,
      onCopyData,
      onScheduleData,
      onPublishData,
      scrollHandleToEnd,
      // inputSearchQuery,
      fetchNews,
      openSendNews,
      closeView,
      updateEventStatus,
      changeToUpdatingFilter,
      onCloseSendNews,
      removeDashboardParams,
      closeDashBoard,
      openCalendar,
      closeCalendar,
      onFilterSubject,
      onFilterUser,
      onFilterOrigin,
      onFilterFlashes,
      onFilterHighlight,
      onFilterExclusive,
      onFilterImportant,
      onFilterInLive,
      onSelectTemplateFilter,
      onSelectNewsTypeFilter,
      openRelatedNews,
      hotKeyCreateNewsTab,
      hotKeyCreateFlashesTab,
      hotKeyCreateTvCastTab,
      hotKeyCreatePodcastTab,
      hotKeyCreateReportTab,
      onDeleteAllDraftNews,
      onDisableData,
      onCancelData,
      onReIndexNews,
      onRefreshNews,
      onRemoveFromElastic,
      onRestoreToElastic,
      onVectorizeNews,
      stateFilter,
      currentEventStatus,
    };
  },
};
</script>
